/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Unit_Request_PluralInputs */

const en_measure_unit_request_plural = /** @type {(inputs: Measure_Unit_Request_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`requests`)
};

const zh_hans1_measure_unit_request_plural = /** @type {(inputs: Measure_Unit_Request_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请求`)
};

const pt_br2_measure_unit_request_plural = /** @type {(inputs: Measure_Unit_Request_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`requisições`)
};

const es_measure_unit_request_plural = /** @type {(inputs: Measure_Unit_Request_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`solicitudes`)
};

const fr_measure_unit_request_plural = /** @type {(inputs: Measure_Unit_Request_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`requêtes`)
};

const de_measure_unit_request_plural = /** @type {(inputs: Measure_Unit_Request_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfragen`)
};

const ru_measure_unit_request_plural = /** @type {(inputs: Measure_Unit_Request_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`запросов`)
};

const it_measure_unit_request_plural = /** @type {(inputs: Measure_Unit_Request_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`richieste`)
};

/**
* | output |
* | --- |
* | "requests" |
*
* @param {Measure_Unit_Request_PluralInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_request_plural = /** @type {((inputs?: Measure_Unit_Request_PluralInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Request_PluralInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_request_plural(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_request_plural(inputs)
	if (locale === "es") return es_measure_unit_request_plural(inputs)
	if (locale === "fr") return fr_measure_unit_request_plural(inputs)
	if (locale === "de") return de_measure_unit_request_plural(inputs)
	if (locale === "ru") return ru_measure_unit_request_plural(inputs)
	if (locale === "it") return it_measure_unit_request_plural(inputs)
	return en_measure_unit_request_plural(inputs)
});